import { SET_LATEST_PAYMENT_INFORMATION, SET_IS_CLOCK_IN_SUGGESTION_MODAL_OPEN, SET_TOKEN, UPDATE_POPOVER, SET_MESSAGE_ID, SET_SHOW_CONFORMATION_MODAL, SET_IS_LOADING_MODAL, SET_IS_LOADING_MORE, SET_IS_LOADING, SET_PULLING_DATA, SET_SELECTED_NETWORK, SET_HIDE_REFRESH_TOAST, SET_SHOW_SETTINGS_REFRESH_TOAST, SET_SHOW_REFRESH_TOAST, SET_HIDE_TOAST, SET_SHOW_TOAST, SET_IS_WS_ACTIVE, SET_NETWORK_STATUS } from './chunk-P7VATSOY.mjs';
import { __spreadValues, __spreadProps } from './chunk-T36PI2YV.mjs';
import { produce } from 'immer';

var CONFIRMATION_MODAL_INITIAL_STATE = {
  title: "",
  name: "",
  active: false,
  type: "info",
  onCancel: () => null,
  onSuccess: () => null,
  btnCancelText: "Cancel",
  btnSuccessText: "Ok",
  description: "Description",
  runCancelOnClickOutside: false
};
var POPOVER_INITIAL_STATE = {
  isActive: false,
  position: "right" /* RIGHT */,
  offset: {
    x: 0,
    y: 0,
    ox: 0,
    oy: 0,
    width: 0,
    height: 0
  },
  popoverId: "NONE" /* NONE */,
  resetDataOnClose: true,
  triggerClose: void 0
};
var TT_KEYBOARD_INITIAL_STATE = {
  isActive: false,
  type: "default",
  hasModalParent: false,
  multiline: false,
  enableCaps: false
};
var CORE_APP_INITIAL_STATE = {
  networkStatus: "default" /* DEFAULT */,
  selectedNetwork: {
    SSID: "",
    password: ""
  },
  isPullingData: {
    isDownloading: false,
    percentCompleted: 0
  },
  isLoading: false,
  isLoadingMore: false,
  isLoadingModal: {
    active: false,
    message: ""
  },
  toast: {
    id: "",
    isActive: false,
    title: "",
    description: "",
    type: "info"
  },
  toastManager: [],
  lockScreenBanner: {
    id: "",
    isActive: false,
    title: "",
    description: "",
    type: "info"
  },
  refreshToast: {
    id: "",
    isActive: false,
    title: "",
    variant: null
  },
  popover: POPOVER_INITIAL_STATE,
  confirmationModal: CONFIRMATION_MODAL_INITIAL_STATE,
  isClockInSuggestionModalOpen: false,
  messageId: "",
  token: "",
  isWSActive: true,
  keyboard: TT_KEYBOARD_INITIAL_STATE,
  latestPaymentInformation: null,
  initializeAppOnLockScreen: false,
  confirmationModalQueue: null
};
var appReducer = produce(
  (state = CORE_APP_INITIAL_STATE, action) => {
    switch (action.type) {
      case SET_NETWORK_STATUS:
        state.networkStatus = action.payload;
        break;
      case SET_IS_WS_ACTIVE:
        state.isWSActive = action.payload;
        break;
      case SET_SHOW_TOAST:
        state.toast = __spreadProps(__spreadValues({}, action.payload), {
          isActive: true
        });
        state.toastManager.push(state.toast);
        break;
      case SET_HIDE_TOAST:
        state.toast.isActive = false;
        break;
      case SET_SHOW_REFRESH_TOAST:
        state.refreshToast = __spreadProps(__spreadValues({}, action.payload), {
          isActive: true
        });
        break;
      case SET_SHOW_SETTINGS_REFRESH_TOAST:
        state.refreshToast = __spreadProps(__spreadValues({}, action.payload), {
          isActive: true
        });
        break;
      case SET_HIDE_REFRESH_TOAST:
        state.refreshToast.isActive = false;
        break;
      case SET_SELECTED_NETWORK:
        state.selectedNetwork = {
          SSID: Object.prototype.hasOwnProperty.call(action.payload, "SSID") ? action.payload.SSID : state.selectedNetwork.SSID,
          password: action.payload.password
        };
        break;
      case SET_PULLING_DATA:
        state.isPullingData = action.payload;
        break;
      case SET_IS_LOADING:
        state.isLoading = action.payload;
        break;
      case SET_IS_LOADING_MORE:
        state.isLoadingMore = action.payload;
        break;
      case SET_IS_LOADING_MODAL:
        state.isLoadingModal = action.payload;
        break;
      case SET_SHOW_CONFORMATION_MODAL:
        state.confirmationModal = action.payload;
        break;
      case SET_MESSAGE_ID:
        state.messageId = action.payload;
        break;
      case UPDATE_POPOVER:
        state.popover = __spreadValues(__spreadValues({}, state.popover), action.payload);
        break;
      case SET_TOKEN:
        state.token = action.payload;
        break;
      case SET_IS_CLOCK_IN_SUGGESTION_MODAL_OPEN:
        state.isClockInSuggestionModalOpen = action.payload;
        break;
      case SET_LATEST_PAYMENT_INFORMATION:
        state.latestPaymentInformation = action.payload;
        break;
      default:
        return state;
    }
  }
);
var reducers_default = appReducer;

export { CONFIRMATION_MODAL_INITIAL_STATE, CORE_APP_INITIAL_STATE, POPOVER_INITIAL_STATE, TT_KEYBOARD_INITIAL_STATE, reducers_default };
